//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { cast, flow, getEnv, getSnapshot, types } from "mobx-state-tree";

const UploadFile = types.model("UploadFile", {
  preview: types.optional(types.string, ""),
  name: types.optional(types.string, ""),
  public_id: types.optional(types.string, ""),
  size: types.optional(types.string, ""),
  url: types.string,
});

export const UploadStore = types
  .model("UploadStore", {
    files: types.optional(types.array(UploadFile), []),
    isUploading: types.optional(types.boolean, false),
    percent: types.optional(types.number, 0),
  })
  .views((self) => {
    return {
      get rawFiles() {
        return getSnapshot(self.files) || [];
      },
      get cleanedFiles() {
        return null;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    const onDrop = flow(function* onDrop(files, progressCallback = () => {}) {
      self.isUploading = true;
      try {
        let results = yield adapter.cloudinaryApiHandler(
          files,
          progressCallback,
        );
        results.forEach((f) => {
          self.files.push({ ...f, public_id: f.id });
        });
        self.isUploading = false;
      } catch (error) {
        self.isUploading = false;
        throw error;
      }
    });
    return {
      onDrop,
      clearFiles() {
        self.files = cast([]);
      },
      progressCallback(progress) {
        self.percent = progress;
      },
      onRawDelete(f) {
        adapter.remoteDeleteImage(f);
      },
      onDeleteFile(index) {
        let f = getSnapshot(self.files[index]);
        self.files = cast(
          self.files.filter((_, fileIndex) => fileIndex !== index),
        );
        adapter.remoteDeleteImage(f);
      },
    };
  });
